import request from '../utils/axios';
// 宝汇
const base = 'https://www.prowayfx.com/';
// 鑫盛
const xsApi = 'https://webapi.kiebnk.com';
// 测试
const textApi = 'http://testcrmapi.xs9999.com.hk';

const xaApi = 'https://crmapi.xs9999.com.hk/';
// index--昨收报价
export function quote(data) {
  return request({
    url:'https://sem.rlclead.com/api/quote/v1/QF1002',
    method: 'POST',
    data
  })
}
// notice--平台公告详情页
export function noticeDetails(data){
  return request({
    url: xaApi + '/v4/XACMS0002',
    method: 'POST',
    data
  })
}
// index--行情
export function quoteTime(data) {
  return request({
    url:'https://sem.rlclead.com/api/quote/v1/QF1001',
    method: 'POST',
    data
  })
}
// Notice--平台公告
export function noticeInit(data){
  return request({
    url: xaApi + '/v4/XACMS0001',
    method: 'POST',
    data
  })
}
// news--新闻详情页
export function newsDetails(data){
  return request({
    url: xsApi + '/v4/I109',
    method: 'POST',
    data
  })
}